import DeliveryContactModelBase from '../_generated/modelBases/delivery-contact-model-base';

export default class DeliveryContactModel extends DeliveryContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
